import type { Testimonial } from '../testimonials'

export const added: Testimonial = {
  company: 'Kuveyt Türk',
  logo: { name: 'Kuveyt Türk', src: '/logo/kuveytturk.webp' },
  portrait: { src: '/photo/portrait-okan-acar.png', alt: 'Okan Acar' },
  quote: [
    'Digitopia understands the client. They have a wide perspective, extensive know-how and '
    + 'can speak on all matters. Digitopia connected us with several executives from other '
    + 'companies who work on similar challenges.',
  ],
  attribution: 'Okan Acar, Chief Digital Banking and Payment Systems Officer',
}

/** Its place on the wall — the order the live page lists them in. */
export const order = 17
